export default {
  tiles: [
    {
      id: 0,
      backgroundColor: '#B7ECDA',
      title: 'Consumer, Company, Team, Self',
      copy: "We lean on each other to succeed. Understanding different viewpoints and celebrating our coworkers' wins lead to stronger decisions and teams.",
      imageMobile:
        'https://www.nerdwallet.com/cdn/company/2024/values/Company-Carousel-01-sfw-mobile-v2.jpg',
    },
    {
      id: 1,
      backgroundColor: '#C8E4FE',
      title: 'Relentless Self-Improvement',
      copy: "We take responsibility for getting better every day. We humbly embrace what we don't know and aren't afraid to ask questions.",
      imageMobile:
        'https://www.nerdwallet.com/cdn/company/2021/values/Company-Values-Photos-Mobile@2x_0002_Relentless-self-improvement.jpg',
    },
    {
      id: 2,
      backgroundColor: '#F2EDE6',
      title: 'Open, Candid, and Constructive',
      copy: 'We are active participants in every interaction. We share feedback with clarity and receive feedback with courage.',
      imageMobile:
        'https://www.nerdwallet.com/cdn/company/2021/values/Company-Values-Photos-Mobile@2x_0003_Open-candid-and-constructive.jpg',
    },
    {
      id: 3,
      backgroundColor: '#C8E4FE',
      title: 'Informed Risk-Taking',
      copy: "We set actionable goals that challenge the status quo, knowing it's safe to fail so long as we learn along the way.",
      imageMobile:
        'https://www.nerdwallet.com/cdn/company/2024/values/Company-Carousel-03-sfw-mobile.jpg',
    },
    {
      id: 4,
      backgroundColor: '#B7ECDA',
      title: 'Ownership',
      copy: 'We ask, “What can I do to improve the results?” and view challenges as opportunities to find the right solution.',
      imageMobile:
        'https://www.nerdwallet.com/cdn/company/2024/values/Company-Carousel-05-sfw-mobile.jpg',
    },
  ],
};
